import React from 'react';
import { observer } from 'mobx-react';

// Translations
export default function translate(key) {
  return Component => {
    class TranslationComponent extends React.Component {
      componentWillMount() {
        // Get the current translation data
        const { SessionStore } = this.props.store;
        if(!SessionStore.translationLoaded) {
          SessionStore.getTranslation(SessionStore.locale);
        }
      }

      render() {
        const { SessionStore } = this.props.store;

        if(SessionStore.translation) {
          // Return the translation for the provided component (key)
          let translation = SessionStore.translation[key];
          return <Component {...this.props} translation={translation} />
        } else {
          return null;
        }
      }
    }

    return observer(TranslationComponent);
  };
}



// WEBPACK FOOTER //
// ./src/app/components/Translate.js